<template>
  <div class="ut-container-lg ut-pb-8" v-if="user && user.key" v-cloak>
    <div v-if="(isPrincipal || isManager) && isPremier">
      <div v-if="isDeviceVerified || isValidOAUser()">
        <article>
          <div class="page-heading">
            <h1>Dashboard</h1>
            <div
              class="heading-badge"
              v-tooltip="{
                content: premierInfoText,
                classes: ['info'],
                trigger: 'hover click',
              }"
            >
              PREMIER
            </div>
            <select-list
              class="ut-mr-0 ut-hidden md:ut-block"
              :options="leadFilterOptions"
              v-model="selectedLeadFilterVal"
              @input="updateLeadFilter"
              data-oa-name="dropdown-lead"
            ></select-list>

            <select-list
              class="ut-mr-0 ut-hidden md:ut-block ut-ml-4"
              :options="timeFrameFilterOptions"
              v-model="selectedTimeFrame"
              @input="updateTimeFrameFilter"
              data-oa-name="dropdown-time"
            ></select-list>
          </div>
        </article>
        <performance-premier-section
          v-if="statsLoaded"
          :accountid="user.accountid"
          :groupStats="groupStats"
          data-oa-name="performance-premier-section"
        />

        <performance-agents-section
          v-if="statsLoaded"
          :groupStats="groupStats"
          :agencyStats="agencyStats"
          :agentStats="agentStats"
          :competitiveStats="competitiveStats"
          :isManager="isManager"
          :isPrincipal="isPrincipal"
          data-oa-name="performance-agents-section"
        />

        <div v-if="statsLoaded">
          <h2 class="ut-text-xl ut-font-semibold ut-mb-6">
            Requires attention
          </h2>
          <leads-activity-section
            v-if="hasRequiredAttentionLams"
            :ak="ak"
            :leadActivities="attentionLams"
            :type="'Attention'"
            :stateName="'Open'"
            :isLoading="loadingMoreLams"
            :hideLoadMore="true"
          />
          <load-more
            @click.native="redirectToLeads"
            :text="'View all leads'"
            :active="false"
          />
        </div>
      </div>
      <user-device-verification v-else>
        <template v-slot:header>
          <div class="page-heading">
            <h1>Dashboard</h1>
            <div
              class="heading-badge"
              v-tooltip="{
                content: premierInfoText,
                classes: ['info'],
                trigger: 'hover click',
              }"
            >
              PREMIER
            </div>
          </div>
        </template>
      </user-device-verification>
    </div>
    <div v-else>
      <div class="ut-flex ut-pb-6 ut-pt-12 md:ut-pb-12">
        <h1 class="sub-heading">Please activate your dashboard</h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from "vuex";
import LeadsActivitySection from "@/components/LeadsActivitySection.vue";
import LoadMore from "@/components/loading/LoadMore.vue";
import PerformancePremierSection from "@/components/PerformancePremierSection.vue";
import PerformanceAgentsSection from "@/components/PerformanceAgentsSection.vue";
import UserDeviceVerification from "@/components/UserDeviceVerification.vue";
import SelectList from "@/components/Forms/SelectList.vue";
import helpers from "@/helpers/common-helpers";
import cookieHelpers from "@/helpers/cookie-helpers";

export default {
  name: "DashboardV2",
  components: {
    LeadsActivitySection,
    LoadMore,
    PerformancePremierSection,
    PerformanceAgentsSection,
    SelectList,
    UserDeviceVerification,
  },
  props: {
    ak: { required: false },
  },
  data() {
    const isPremier = helpers.getUrlNum("ispremier") === 1 ? 1 : 0;

    return {
      statsLoaded: false,
      agentStats: [],
      competitiveStats: [],
      agencyStats: [],
      groupStats: [],
      timeFrameFilterOptions: [
        {
          val: 0,
          value: "thisMonth",
          text: "This month",
          selected: false,
        },
        {
          val: 1,
          value: "lastMonth",
          text: "Last month",
          selected: false,
        },
        {
          val: 12,
          value: "12Months",
          text: "Last 12 months",
          selected: true,
        },
        {
          val: -1,
          value: "allTime",
          text: "All time",
          selected: false,
        },
      ],
      leadFilterOptions: [
        { value: 0, text: "All leads", selected: isPremier !== 1 },
        { value: 1, text: "Leads since premier", selected: isPremier === 1 },
      ],
      selectedLeadFilterVal: isPremier,
      selectedTimeFrame: "12Months",
      selectedTimeFramVal: 12,
      // agentFilterOptions: [
      //   { value: null, text: 'All Agents', selected: true },
      // ],
      selectedAgent: null,
      loadingMoreLams: false,
      premierInfoText: "",
    };
  },
  computed: {
    ...mapState({
      agent: (state) => state.agentStore.agent,
      user: (state) => state.userStore.user,
      attentionLams: (state) => state.premierLeadsListStore.attentionLeadsList,
      openLams: (state) => state.premierLeadsListStore.openLeadsList,
      agentsForPrincipal: (state) => state.principalStore.agentsForPrincipal,
    }),
    ...mapGetters("userStore", [
      "isPremier",
      "isPrincipal",
      "isManager",
      "isDeviceVerified",
    ]),
    ...mapGetters("principalStore", ["agentFilterList"]),
    hasRequiredAttentionLams() {
      return (
        this.attentionLams &&
        this.attentionLams.total &&
        this.attentionLams.total > 0
      );
    },
    needsRedirectToLeads() {
      return (
        this.isPremier &&
        this.isPrincipal &&
        this.$helpers.getUrlParam("utm_source") === "email" &&
        this.$helpers.getUrlParam("utm_campaign") ===
          "email-principal-agent-post-referral-2h-followup"
      );
    },
  },
  mounted() {
    if (this.$route.query.status || this.$route.query.agent) {
      window.location.href = "#referrals-activity";
    }
    this.$store.subscribe((mutation) => {
      switch (mutation.type) {
        case "userStore/setUser":
          if (this.needsRedirectToLeads) {
            this.redirectToLeads();
          } else if (!this.openLams || this.openLams.length === 0) {
            // prepare Require Attention Section
            // if (!this.openLams || this.openLams.length === 0) {
            this.getLams("Open", "Both");
            // }
          }
          break;
        default:
          break;
      }
    });
  },
  watch: {
    agentFilterList() {
      if (this.$route.query.agent) {
        this.updateAgentFilter(this.$route.query.agent);
      }
    },
  },
  created() {
    const isPremierParam = helpers.getUrlNum("ispremier");
    const isPremier = isPremierParam === null ? 1 : isPremierParam;
    this.updateLeadFilter(isPremier);

    // prepare agents filter
    // this.getAgentsForPrincipal();

    if (this.$route.query.timeframe) {
      this.updateTimeFrameFilter(this.$route.query.timeframe);
    }

    // prepare Require Attention Section
    if (
      this.user &&
      this.user.key &&
      this.user.key.length > 0 &&
      (!this.openLams || this.openLams.length === 0)
    ) {
      this.getLams("Open", "Both");
    }
    this.getSnippets();
  },
  methods: {
    ...mapActions("premierLeadsListStore", ["loadPremierLeadsList"]),
    getAgentStatsParams() {
      const data = {};
      const premierSelected = parseInt(this.selectedLeadFilterVal, 10) === 1;

      if (this.selectedTimeFrame) {
        data.timeFrame = this.selectedTimeFrame;
      }
      if (premierSelected) {
        data.isPremier = true;
      }
      return data;
    },
    getCompetitiveStatsParams() {
      const data = {};
      if (this.selectedTimeFrame) {
        data.timeFrame = this.selectedTimeFrame;
      }
      return data;
    },
    getLeadParams() {
      const data = {};
      if (this.selectedTimeFramVal) {
        data.monthsAgo = this.selectedTimeFramVal;
      }
      if (this.selectedLeadFilterVal === 1) {
        data.premier = this.selectedLeadFilterVal;
      }
      if (this.selectedStatus) {
        data.statusFilter = this.selectedStatus;
      }
      if (this.selectedAgent) {
        data.agentKey = this.selectedAgent;
      }
      return data;
    },
    showStats() {
      const paramsAgent = this.getAgentStatsParams();
      const paramsCompetitive = this.getCompetitiveStatsParams();

      this.$apiServices.oa.user
        .getAgentStats(this.$route.params.uk, paramsAgent)
        .then(this.setAgentStats, console.error)
        .catch(console.error)
        .finally(() => {
          this.statsLoaded = true;
        });

      this.$apiServices.oa.user
        .getCompetitiveStats(this.$route.params.uk, paramsCompetitive)
        .then(this.setCompetitiveStats, console.error)
        .catch(console.error);
    },
    setAgentStats(statsData) {
      this.agentStats = [];
      this.agencyStats = [];
      this.groupStats = [];

      const hasStatsData = statsData && statsData.length;
      if (hasStatsData) {
        // Agent Stats  (statsTypeId: 1)
        if (statsData.filter((a) => a.statsTypeId === 1).length > 0) {
          this.agentStats = statsData.filter((a) => a.statsTypeId === 1);
        }

        // Agency Stats (statsTypeId: 2)
        if (statsData.filter((a) => a.statsTypeId === 2).length > 0) {
          this.agencyStats = statsData.filter((a) => a.statsTypeId === 2);
        }

        // Agency Group Stats (statsTypeId: 3)
        if (statsData.filter((a) => a.statsTypeId === 3).length > 0) {
          this.groupStats = statsData.filter((a) => a.statsTypeId === 3);
          this.groupStats =
            this.groupStats.length !== 0
              ? this.groupStats[0].stats
              : this.groupStats[0];
        } else if (this.agencyStats.length === 1) {
          // IF: we have no Agency Group and only 1 agency
          // Lets set the agency stats as the agency group
          this.groupStats = this.agencyStats[0].stats;
        } else if (this.agencyStats.length > 1) {
          // IF: We have no Agency Group and more than 1 agency
          this.groupStats = {
            referrals: 0,
            goToMarkets: 0,
            listings: 0,
            shownToVendor: 0,
          };

          // Lets add the agency stats and set them as the agency group
          this.agencyStats.forEach((agency) => {
            this.groupStats.referrals += agency.stats.referrals;
            this.groupStats.goToMarkets += agency.stats.goToMarkets;
            this.groupStats.listings += agency.stats.listings;
            this.groupStats.shownToVendor += agency.stats.shownToVendor;
          });
        } else if (!this.agencyStats.length) {
          this.groupStats = {
            referrals: 0,
            goToMarkets: 0,
            listings: 0,
            shownToVendor: 0,
          };
          this.agentStats.forEach((agent) => {
            this.groupStats.referrals += agent.stats.referrals;
            this.groupStats.goToMarkets += agent.stats.goToMarkets;
            this.groupStats.listings += agent.stats.listings;
            this.groupStats.shownToVendor += agent.stats.shownToVendor;
          });

          this.agencyStats = [this.agentStats[0]];
        }
      } else if (!this.statsLoaded) {
        this.statsLoaded = true;
        this.updateLeadFilter(0);
      }
    },
    setCompetitiveStats(competitiveStats) {
      const hasStats = competitiveStats && competitiveStats.length > 0;
      this.competitiveStats = hasStats ? competitiveStats[0] : null;
    },
    // getAgentsForPrincipal() {
    //   this.$apiServices.oa.user.getAgentsForPrincipal(this.$route.params.uk)
    //     .then((agentsData) => {
    //       if (agentsData) {
    //         this.initAgentsForPrincipal(agentsData);
    //       }
    //     }, (err) => {
    //       // reject(err);
    //       console.log(err);
    //     });
    // },
    // initAgentsForPrincipal(data) {
    //   if (data) {
    //     for (const d of data) {
    //       this.agentFilterOptions.push({ value: d.Key, text: d.FullName, selected: false });
    //     }
    //   }
    // },
    getLams(status, leadMode = "All") {
      const payload = {
        userKey: this.user.key,
        statusFilter: status,
        leadMode,
      };

      payload.agentKey = this.selectedAgent;

      this.loadingMoreLams = true;
      this.loadPremierLeadsList(payload).then(() => {
        this.loadingMoreLams = false;
      });
    },
    updateTimeFrameFilter(value) {
      this.selectedTimeFrame = value;
      this.timeFrameFilterOptions.forEach((option) => {
        const timeframe = option;
        if (option.value === value) {
          timeframe.selected = true;
          this.selectedTimeFramVal = option.val;
        } else {
          timeframe.selected = false;
        }
      });

      this.showStats();
    },
    updateLeadFilter(value) {
      this.selectedLeadFilterVal = value;

      this.leadFilterOptions.forEach((option) => {
        const lead = option;
        if (option.value === this.selectedLeadFilterVal) {
          lead.selected = true;
        } else {
          lead.selected = false;
        }
      });

      this.showStats();
    },
    updateAgentFilter(value) {
      this.selectedAgent = value;
      this.agentFilterList.forEach((option) => {
        const agent = option;
        if (option.value === value) {
          agent.selected = true;
        } else {
          agent.selected = false;
        }
      });
    },
    redirectToLeads() {
      if (this.isPrincipal) {
        this.$router.push({
          path: `${this.ak ? `/${this.ak}` : ""}/leads/${
            this.$route.params.uk
          }`,
        });
      }
    },
    getSnippets() {
      const data = {
        snippettitlelist:
          "premier-program-i-text,premier-program-i-text-start-date",
      };

      this.$apiServices.oa.article.getSnippets(data).then(
        (snippets) => {
          let startDate = "";

          this.$apiServices.oa.account
            .getPremierStartDate(this.user.key)
            .then((date) => {
              startDate = this.$helpers.convertFromUTC(date);

              this.premierInfoText =
                snippets.length > 1
                  ? decodeURIComponent(snippets[0].snippetbody) +
                    (startDate != ""
                      ? decodeURIComponent(snippets[1].snippetbody).replace(
                          "%PREMIER_START_DATE%",
                          startDate
                        )
                      : "")
                  : null;
            });
        },
        (err) => {
          console.log(err);
          this.premierInfoText = null;
        }
      );
    },
    isValidOAUser() {
      return cookieHelpers.verifyValidOAUser();
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.sub-heading {
  @apply ut-mt-12 ut-mb-6 ut-text-xl ut-font-bold;
  letter-spacing: -0.2px;
  line-height: 25px;
}

.no-info {
  @apply ut-p-4;
  color: #00393e;
  font-size: 14px;
  font-weight: 700;
  line-height: 18px;
}

.heading-badge {
  @apply ut-ml-3 ut-mt-3 ut-rounded ut-text-center ut-block ut-text-neutral-001 ut-bg-green-200;
  height: 18px;
  width: 64px;
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  line-height: 18px;

  &:hover {
    cursor: pointer;
  }
}
</style>
